import * as _ from 'lodash';

export class User {
  userId: string;
  fullName: string;
  pointOfContact: number;
  address: string;
  profileImage: string;
  mobile: string;
  status: number;
  createdOn: string;
  modifiedOn: string;
  email: string;
  fName: string;
  lName: string;
  roleIds: object;
  type: object;
  roles: object;
  locationIds: object;
  locations:object[];
  countryCode:string;
   constructor(data: any) {
     this.userId = data.userId;
     this.fullName = data.fullName;
     this.email = data.email;
     this.mobile = data.mobile;
     this.createdOn = data.createdOn;
     this.status = data.status;
     this.address = data.address;
     this.profileImage = data.profileImage;
     this.modifiedOn = data.modifiedOn;
     this.roles = data.roles;
     this.type = data.userType;
     this.locationIds=data.locationIds;
     this.locations=data.locations;
     this.countryCode = data.countryCode;
   }

}

export class Role {
  roleId: string;
  roleName: string;
  isCustom: number;
  actionPairs: any[];
  resourceName: string;


  constructor(data: any) {
    this.roleId = data.roleId;
    this.roleName = getRoleName(data.roleName);
    this.isCustom = data.isCustomRole;
    this.actionPairs = getPairs(data.resourceActionPairs);
  }

}

function getPairs(pairs) {
  const resourcePairs = [];
  _.forEach(pairs, (pair) => {
    const resource = {};
    resource['resourceName'] = pair.resourceName;
    resource['actions'] = pair.actions;
    resourcePairs.push(resource);
  });
  return resourcePairs;
}

function getRoleName(name) {
  let roleName = name.split('_');
  roleName = roleName.join(' ');
  return roleName;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/components/users/models/user.ts